"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TeacherAndParentLogin = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./styles.scss");
var _loginForm = require("../../schoolUiComponents/loginForm");
var _state = require("./../../authSignin/state");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var TeacherAndParentLogin = function TeacherAndParentLogin(_ref) {
  var _ref$isTeacher = _ref.isTeacher,
    isTeacher = _ref$isTeacher === void 0 ? false : _ref$isTeacher,
    _ref$isParent = _ref.isParent,
    isParent = _ref$isParent === void 0 ? false : _ref$isParent;
  var _useAuthSigninState = (0, _state.useAuthSigninState)(),
    sendEvent = _useAuthSigninState.sendEvent;
  var teacherParentTabSwitchEvent = function teacherParentTabSwitchEvent(page) {
    trackPageViewOnGa('login-popup');
    sendEvent("Login as ".concat(page));
    window.location.hash = page;
  };
  (0, _react.useEffect)(function () {
    localStorage.setItem("showClassroomActivitySelection", "1");
    var script = document.createElement('script');
    script.src = "https://cdn.pagesense.io/js/splashlearn/0763448b82a04ecabdf1f12f3b7a2db1.js";
    document.head.appendChild(script);
    return function () {
      document.head.removeChild(script);
    };
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "teacher-and-parent-login ".concat(isTeacher ? 'teacher' : 'parent'),
    "data-test-id": "parent-and-teacher-login",
    "data-sentry-component": "TeacherAndParentLogin",
    "data-sentry-source-file": "index.tsx"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    className: "login-back dark",
    onClick: function onClick() {
      return window.location.hash = "";
    }
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "iconcust-iconBackBtn"
  })), /*#__PURE__*/_react["default"].createElement("h4", null, "Log In as"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "tab-view"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "tab ".concat(isTeacher ? "active" : ""),
    onClick: function onClick() {
      teacherParentTabSwitchEvent("#teacher");
    },
    "data-test-id": "teacher-tab"
  }, "Teacher"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "tab ".concat(isParent ? "active" : ""),
    onClick: function onClick() {
      teacherParentTabSwitchEvent("#parent");
    },
    "data-test-id": "parent-tab"
  }, "Parent")), /*#__PURE__*/_react["default"].createElement(_loginForm.LoginForm, {
    source: "Parent/Teacher Login",
    sendEvent: sendEvent,
    "data-sentry-element": "LoginForm",
    "data-sentry-source-file": "index.tsx"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "register-link"
  }, "New ", isParent ? "Parents" : "Teacher", "?", " ", /*#__PURE__*/_react["default"].createElement("a", {
    href: isParent ? "/parents/register" : "/teachers/register",
    onClick: function onClick() {
      return sendEvent("Register here: ".concat(isParent ? "/parents/register" : "/teachers/register"));
    }
  }, "Register here")));
};
exports.TeacherAndParentLogin = TeacherAndParentLogin;